var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"height":_vm.height,"width":_vm.width,"id":"financements-percus-beneficiaire-graph"}})
}
var staticRenderFns = []

export { render, staticRenderFns }